import React from 'react';
import Text from '@service-victoria/component-library/components/Text';
import { ExternalLinks } from 'utils/constants';

export const TravelPermitPreamble: React.FC<Record<string, never>> = () => (
  <>
    <Text.Heading.H3 fontWeight='bold'>What type of permit are you applying for?</Text.Heading.H3>
    <Text.Body>You can apply for an international passenger arrivals permit:</Text.Body>
    <Text.Body>
      Depending on your vaccination status and whether you’ve received a negative COVID-19 test
      result within 72 hours of your flight’s scheduled departure.
    </Text.Body>
    <Text.Body>
      If you can’t comply with the conditions of the international passenger arrivals permit, you
      must apply for an 
      <Text.Link href={ExternalLinks.CoronavirusExceptionsAndExemptions} target='_blank'>
        exemption
      </Text.Link>
      .
    </Text.Body>
  </>
);
